<div class="body" style="display: flex; height: 100%;">
	<div style="display: flex; overflow: hidden; width: 100%;">
		<div style="display: flex; flex-direction: column; z-index: 1; overflow: hidden; width: 100%;">
			<div style="font-size: 20px; padding: 26px 0 0 35px;">
				<span class="fal fa-chart-network"></span>
				<span style="padding-left: 10px;">Platform Activity</span>
				<span style="font-size: 12px; color: #747474; margin-left: 13px;">api-v.{{ currentVersion$ | async }}</span>
				<span style="font-size: 12px; color: #747474; margin-left: 13px;">ui-v.{{ currentUIVersion$ | async }}</span>
			</div>
			<div class="lexbe-search-wrapper">
				<div class="lexbe-search-icon-container">
					<span class="fal fa-search"></span>
				</div>
				<div class="lexbe-search-input-container" (click)="lexbeSearch.select()"
					 [ngClass]="{'focus-effects' : isSearchedFocused}">
					<input (keyup.escape)="lexbeSearch.blur()" (focus)="isSearchedFocused = true"
						   (blur)="isSearchedFocused = false" placeholder="Search" [ngModel]="filterText$ | async"
						   (ngModelChange)="setSearchText($event)" #lexbeSearch/>
				</div>
				<div *ngIf="filterText$ | async" class="lexbe-clear-icon-container" (click)="clearFilterText()">
					<span class="fal fa-times"></span>
				</div>
			</div>
			<div style="display: flex; justify-content: space-between; align-items: baseline">
				<div style="padding: 15px 35px; margin-right: auto;">
					<nav mat-tab-nav-bar [tabPanel]="tabPanel" class="tabs-variant-1">
						<a mat-tab-link [routerLink]="['./', 'services']" queryParamsHandling="merge" routerLinkActive #rlaMicroservices="routerLinkActive"
						   [active]="rlaMicroservices.isActive"><span class="fas fa-cubes" style="padding-right: 10px;"></span> Services ({{ (totalMicroservices$ | async | number) || 0 }})</a>
						<a mat-tab-link [routerLink]="['./', 'servers']" queryParamsHandling="merge" routerLinkActive #rlaServers="routerLinkActive"
						   [active]="rlaServers.isActive"><span class="fas fa-server" style="padding-right: 10px;"></span> Servers ({{ (totalServers$ | async | number) || 0 }})</a>
						<a mat-tab-link [routerLink]="['./', 'workflows']" queryParamsHandling="merge" routerLinkActive #activeWorkflows="routerLinkActive"
						   [active]="activeWorkflows.isActive"><span class="fas fa-arrow-progress" style="padding-right: 10px;"></span> Workflows ({{ (totalWorkflows$ | async | number) || 0 }})</a>
						<a mat-tab-link [routerLink]="['./', 'all']" queryParamsHandling="merge" routerLinkActive #rla1="routerLinkActive"
						   [active]="rla1.isActive"><span class="fas fa-microchip" style="padding-right: 10px;"></span> All ({{ (totalQueued$ | async | number) || 0 }})</a>
						<a mat-tab-link [routerLink]="['./', 'active'] "queryParamsHandling="merge" routerLinkActive #rla2="routerLinkActive"
						   [active]="rla2.isActive"><span class="fas fa-microchip" style="padding-right: 10px;"></span> Active ({{ (totalActive$ | async | number) || 0 }})</a>
						<a mat-tab-link [routerLink]="['./', 'snapshot']" queryParamsHandling="merge" routerLinkActive #rla4="routerLinkActive"
						   [active]="rla4.isActive"><span class="fas fa-camera" style="padding-right: 10px;"></span> Snapshot</a>
						<a mat-tab-link [routerLink]="['./', 'index-health']" queryParamsHandling="merge" routerLinkActive #rla5="routerLinkActive"
						   [active]="rla5.isActive"><span class="fas fa-binary-circle-check" style="padding-right: 10px;"></span>Index Health ({{ (totalIndexHealth$ | async | number) || 0 }})</a>
					</nav>
					<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
				</div>
				<div style="padding-right: 37px; font-size: 18px">
					<span class="fal fa-arrows-to-line"></span>
					<mat-slider [min]="0" [max]="50" [step]="1" #ngSlider><input matSliderThumb [value]="38" (change)="setRowHeight(ngSliderThumb.value)" #ngSliderThumb="matSliderThumb"/></mat-slider>
					<span class="fal fa-arrows-from-line"></span>
				</div>
			</div>
			<div style="display: flex; flex-direction: column; flex-grow: 1; overflow: hidden;">
				<router-outlet></router-outlet>
			</div>
		</div>
		<div *ngIf="currentPanel === 'case-priorities'" @inOutAnimation>
			<lex-case-priorities></lex-case-priorities>
		</div>
		<lex-processing-details-pane></lex-processing-details-pane>
	</div>
</div>
